import { AnnualPlanCard } from 'app/components/annual-plan-card';
import { PaymentIntro } from 'app/components/payment-benefits';
import type { ComponentProps } from 'react';

// Checkout currently offers only the annual plan on both platforms.
export function PlanRecurrenceOptions(props: ComponentProps<typeof AnnualPlanCard>) {
  return (
    <>
      <PaymentIntro />
      <AnnualPlanCard {...props} />
    </>
  );
}
